// Keep the catalogue order independent of the display language and the
// Autocomplete's name-based filtering. Both summary fields and full records
// appear here (for example when a saved selection is loaded separately).
export function catalogRatedPower(item, kind) {
  const chars = item?.characteristics || {};
  const candidates = kind === "module"
    ? [item?.pdc, chars.STC, chars.Pmp0]
    : [item?.pac, chars.Paco, chars.Pac, chars.P_AC];
  return candidates.map(Number).find((value) => Number.isFinite(value) && value > 0) ?? null;
}

export function sortCatalogOptionsByPower(items, kind) {
  return [...(items || [])].sort((a, b) => {
    const aPower = catalogRatedPower(a, kind);
    const bPower = catalogRatedPower(b, kind);
    if (aPower == null) return bPower == null ? String(a?.name || "").localeCompare(String(b?.name || "")) : 1;
    if (bPower == null) return -1;
    return aPower - bPower || String(a?.name || "").localeCompare(String(b?.name || ""));
  });
}
